import { render, staticRenderFns } from "./motorcade-detail.vue?vue&type=template&id=7ae08a23"
import script from "./motorcade-detail.vue?vue&type=script&lang=js"
export * from "./motorcade-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports